import { Component, HostBinding } from '@angular/core';

import { PortalBrandingService } from '../../portal-branding.service';

// Fills its parent box with the organisation's logo, or the company initial
// when there's no logo. Used in every logo slot (dashboard header, project
// hero, section footers, login).
@Component({
	selector: 'portal-brand-logo',
	template: `
		<img *ngIf="branding.logoUrl" [src]="branding.logoUrl" alt="" />
		<span *ngIf="!branding.logoUrl">{{ initial }}</span>
	`
})
export class BrandLogoComponent {

	constructor(public branding: PortalBrandingService) {}

	@HostBinding('class.has-logo')
	get hasLogo(): boolean { return !!this.branding.logoUrl; }

	get initial(): string {
		return (this.branding.companyName || '?').trim().charAt(0).toUpperCase();
	}
}
